module.exports = __webpack_public_path__ + "media/images/logo/Logo-Moovejob-CMJN-fond-transparent-pret-de-personnel-36168aee9a2e26c89625328e4accc6eb.png";